import React, { useState, useImperativeHandle } from "react";
import '../../styles/main.css';
import '../../styles/TextEditor/TextEditor.css';
import i18n from '../../i18n';
import * as FxLog from '../fx/FxLog';
import CxTooltip from './CxTooltip';
import { useStyles } from "./StylesCx";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const CxTextEditor = props => {
  const classes = useStyles(props);

  const {
    plugins = [],
    buttonList = [],
    defaultValue,
  } = props;

  const [myValue, setMyValue] = useState(defaultValue || '');
  const [isRequired, setIsRequired] = useState(false);
  const [wasChanged, setChanged] = useState(false);

  const rf_control = React.useRef(null);

  React.useEffect(() => {
    setIsRequired(props.required);
  }, [props.required]);

  React.useEffect(() => {
    FxLog.infox('CxTextEditor.useEffect', '...myValue:', myValue);
  }, [myValue]);

  useImperativeHandle(props.xref, () => ({
    getType: () => 'CxTextEditor',
    setVal: setMyValue,
    getVal: () => myValue,
    getIsRequired: () => isRequired && !myValue,
    getLabel: () => props.label,
    getDbfield: () => props.dbfield,
    setFocus: () => rf_control.current?.focus(),
    isEmpty: () => !myValue,
    clear: () => { setMyValue(''); setChanged(true); },
    wasChanged,
    setChanged
  }));

  return (
    <CxTooltip text={props.tooltip || null}>
      <div className={classes.frame}>
        <SunEditor
          getSunEditorInstance={editor => rf_control.current = editor}
          lang={i18n.language.substring(0, 2)}
          height="100%"
          value={myValue}
          setContents={myValue}
          onChange={setMyValue}
          onKeyDown={() => setChanged(true)}
          onBlur={() => props.onBlur?.(props.dbfield, myValue)}
          setDefaultStyle="font-family: sans-serif; font-size: 14px; text-align: left;"
          setOptions={{
            plugins,
            buttonList
          }}
        />
      </div>
    </CxTooltip>
  );
};

export default CxTextEditor;
